/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/* eslint-disable max-len */

export const AUTHENTICATED = 'authenticated';

export const APPLICATIONS = `${AUTHENTICATED}.application`;
export const OPERATIONS = `${AUTHENTICATED}.operations`;
export const TEMPLATES = `${AUTHENTICATED}.profile`;
export const INFRASTRUCTURE = `${AUTHENTICATED}.infrastructure`;
export const ADMINISTRATION = `${AUTHENTICATED}.administration`;

/**
 * Applications
 */

export const APPLICATIONS_DASHBOARD = `${APPLICATIONS}.dashboard`;
export const APPLICATIONS_VS = `${APPLICATIONS}.virtualservice`;
export const APPLICATIONS_VS_VIP = `${APPLICATIONS}.vs-vip`;
export const APPLICATIONS_POOL = `${APPLICATIONS}.pool`;
export const APPLICATIONS_POOL_GROUP = `${APPLICATIONS}.pool-group`;
export const APPLICATIONS_GSLBSERVICE = `${APPLICATIONS}.gslbservice`;

export const VS_VS_LIST = `${APPLICATIONS_VS}.virtualservice-list`;
export const VS_VS_DETAIL = `${APPLICATIONS_VS}.virtualservice-detail`;

export const VS_DETAIL_ANALYTICS = `${VS_VS_DETAIL}.analytics`;
export const VS_DETAIL_VS_LOGS = `${VS_VS_DETAIL}.vs-logs`;
export const VS_DETAIL_HS_INSIGHTS = `${VS_VS_DETAIL}.hs-insights`;
export const VS_DETAIL_SECURITY = `${VS_VS_DETAIL}.security`;
export const VS_DETAIL_INSIGHTS = `${VS_VS_DETAIL}.insights`;
export const VS_DETAIL_EVENTS = `${VS_VS_DETAIL}.events`;
export const VS_DETAIL_ALERTS = `${VS_VS_DETAIL}.alerts`;
export const VS_DETAIL_DNS_RECORDS = `${VS_VS_DETAIL}.dns-records`;
export const VS_DETAIL_TOPOLOGY = `${VS_VS_DETAIL}.topology`;

export const VS_DETAIL_SECURITY_LEGACY_SECURITY = `${VS_DETAIL_SECURITY}.legacy-security`;
export const VS_DETAIL_SECURITY_SECURITY_DASHBOARD = `${VS_DETAIL_SECURITY}.security-dashboard`;

export const POOL_POOL_LIST = `${APPLICATIONS_POOL}.pool-list`;
export const POOL_POOL_DETAIL = `${APPLICATIONS_POOL}.pool-detail`;

export const POOL_DETAIL_ANALYTICS = `${POOL_POOL_DETAIL}.analytics`;
export const POOL_DETAIL_HS_INSIGHTS = `${POOL_POOL_DETAIL}.hs-insights`;
export const POOL_DETAIL_EVENTS = `${POOL_POOL_DETAIL}.events`;
export const POOL_DETAIL_ALERTS = `${POOL_POOL_DETAIL}.alerts`;
export const POOL_DETAIL_POOL_LOGS = `${POOL_POOL_DETAIL}.pool-logs`;
export const POOL_DETAIL_SERVER = `${POOL_POOL_DETAIL}.server`;

export const POOL_HS_INSIGHTS_DEFAULT = `${POOL_DETAIL_HS_INSIGHTS}.default`;

export const POOL_SERVER_LIST = `${POOL_DETAIL_SERVER}.server-list`;
export const POOL_SERVER_DETAIL = `${POOL_DETAIL_SERVER}.server-detail`;

export const POOL_SERVER_DETAIL_ANALYTICS = `${POOL_SERVER_DETAIL}.analytics`;

export const GSLBSERVICE_LIST = `${APPLICATIONS_GSLBSERVICE}.list`;
export const GSLBSERVICE_GSLBSERVICE_DETAIL = `${APPLICATIONS_GSLBSERVICE}.gslbservice-detail`;

export const GSLBSERVICE_DETAIL_MEMBERS = `${GSLBSERVICE_GSLBSERVICE_DETAIL}.members`;
export const GSLBSERVICE_DETAIL_FQDN_LIST = `${GSLBSERVICE_GSLBSERVICE_DETAIL}.fqdn-list`;
export const GSLBSERVICE_DETAIL_TOPOLOGY = `${GSLBSERVICE_GSLBSERVICE_DETAIL}.topology`;
export const GSLBSERVICE_DETAIL_EVENTS = `${GSLBSERVICE_GSLBSERVICE_DETAIL}.events`;

/**
 * Operations
 */

export const OPERATIONS_ALERTS = `${OPERATIONS}.alerts`;
export const OPERATIONS_EVENTS = `${OPERATIONS}.events`;
export const OPERATIONS_SERVICES = `${OPERATIONS}.services`;
export const OPERATIONS_TRAFFIC_CAPTURE = `${OPERATIONS}.traffic-capture`;
export const OPERATIONS_REPORTS = `${OPERATIONS}.reports`;

export const ALERTS_ALL_ALERTS = `${OPERATIONS_ALERTS}.allalerts-list`;
export const ALERTS_ALERT_CONFIG = `${OPERATIONS_ALERTS}.alertconfig-list`;
export const ALERTS_ALERT_ACTIONS = `${OPERATIONS_ALERTS}.alertactions-list`;

export const EVENTS_EVENTS_LIST = `${OPERATIONS_EVENTS}.events-list`;
export const EVENTS_CONFIGURATION = `${OPERATIONS_EVENTS}.configuration`;

export const SERVICES_SYSLOG_LIST = `${OPERATIONS_SERVICES}.syslog-list`;
export const SERVICES_EMAIL_LIST = `${OPERATIONS_SERVICES}.email-list`;
export const SERVICES_SNMP_LIST = `${OPERATIONS_SERVICES}.snmp-list`;

/**
 * Templates
 */

export const TEMPLATES_PROFILES = `${TEMPLATES}.profiles`;
export const TEMPLATES_POLICY = `${TEMPLATES}.policy`;
export const TEMPLATES_GROUP = `${TEMPLATES}.group`;
export const TEMPLATES_SSL = `${TEMPLATES}.ssl`;
export const TEMPLATES_SCRIPTS = `${TEMPLATES}.scripts`;
export const TEMPLATES_AUTOSCALE = `${TEMPLATES}.autoscale`;
export const TEMPLATES_WAF = `${TEMPLATES}.waf`;
export const TEMPLATES_BOT = `${TEMPLATES}.bot`;
export const TEMPLATES_ERROR_PAGE = `${TEMPLATES}.error-page`;
export const TEMPLATES_FILE_OBJECTS = `${TEMPLATES}.file-objects`;

export const PROFILES_APPLICATION_PROFILE = `${TEMPLATES_PROFILES}.applicationprofile-list`;
export const PROFILES_NETWORK_PROFILE = `${TEMPLATES_PROFILES}.networkprofile-list`;
export const PROFILES_PERSISTENCE_PROFILE = `${TEMPLATES_PROFILES}.persistenceprofile-list`;
export const PROFILES_HEALTH_MONITOR = `${TEMPLATES_PROFILES}.healthmonitor-list`;
export const PROFILES_ANALYTICS_PROFILE = `${TEMPLATES_PROFILES}.analyticsprofile-list`;
export const PROFILES_IPAM_PROFILE = `${TEMPLATES_PROFILES}.ipam-profile`;
export const PROFILES_CUSTOM_IPAM_PROFILE = `${TEMPLATES_PROFILES}.custom-ipam-dns`;
export const PROFILES_TRAFFIC_CLONE_PROFILE = `${TEMPLATES_PROFILES}.traffic-clone-profile`;
export const PROFILES_ICAP_PROFILE = `${TEMPLATES_PROFILES}.icap-profile`;

export const POLICY_NAT_POLICY = `${TEMPLATES_POLICY}.nat-policy-list`;
export const POLICY_DNS_POLICY = `${TEMPLATES_POLICY}.dns-policy-list`;
export const POLICY_L4_POLICY = `${TEMPLATES_POLICY}.l4-policy-set-list`;
export const POLICY_NETWORK_SECURITY_POLICY = `${TEMPLATES_POLICY}.network-security-policy-list`;
export const POLICY_HTTP_POLICY_SET = `${TEMPLATES_POLICY}.http-policy-set-list`;
export const POLICY_APPLICATION_INSIGHTS_POLICY = `${TEMPLATES_POLICY}.application-insights-policy-list`;
export const POLICY_POSITIVE_SECURITY_POLICY = `${TEMPLATES_POLICY}.positive-security-policy-list`;

export const GROUP_IP_ADDR_GROUP = `${TEMPLATES_GROUP}.ipaddrgroup-list`;
export const GROUP_STRING_GROUP = `${TEMPLATES_GROUP}.stringgroup-list`;

export const SSL_CERTIFICATE = `${TEMPLATES_SSL}.certificate-list`;
export const SSL_SSL_PROFILE = `${TEMPLATES_SSL}.sslprofile-list`;
export const SSL_PKI_PROFILE = `${TEMPLATES_SSL}.pkiprofile-list`;
export const SSL_AUTH_PROFILE = `${TEMPLATES_SSL}.authprofile-list`;
export const SSL_AUTH_MAPPING_PROFILE = `${TEMPLATES_SSL}.authmappingprofile-list`;
export const SSL_JWT_SERVER_PROFILE = `${TEMPLATES_SSL}.jwt-server-profile-list`;
export const SSL_CERTIFICATE_MANAGEMENT = `${TEMPLATES_SSL}.certificate-management-list`;
export const SSL_IP_REPUTATION = `${TEMPLATES_SSL}.ip-reputation-list`;
export const SSL_GEO_DB = `${TEMPLATES_SSL}.geo-db-list`;
export const SSL_HSM_GROUP = `${TEMPLATES_SSL}.hsmgroup-list`;
export const SSL_SSO_POLICY = `${TEMPLATES_SSL}.sso-policy-list`;
export const SSL_CSRF_POLICY = `${TEMPLATES_SSL}.csrf-policy-list`;
export const SSL_TRUSTED_HOST_PROFILE = `${TEMPLATES_SSL}.trusted-host-profile`;

export const SCRIPTS_DATASCRIPT_SET = `${TEMPLATES_SCRIPTS}.datascriptset-list`;
export const SCRIPTS_CONTROLSCRIPTS_SET = `${TEMPLATES_SCRIPTS}.controlscripts-list`;
export const SCRIPTS_PROTOCOL_PARSER_SCRIPTS = `${TEMPLATES_SCRIPTS}.protocol-parser-scripts-list`;

export const AUTOSCALE_SERVER_AUTOSCALE = `${TEMPLATES_AUTOSCALE}.server-autoscale`;
export const AUTOSCALE_LAUNCH_CONFIG = `${TEMPLATES_AUTOSCALE}.launch-config`;
export const AUTOSCALE_WEBHOOK = `${TEMPLATES_AUTOSCALE}.webhook`;
export const AUTOSCALE_POOL_GROUP_DEPLOYMENT_POLICY = `${TEMPLATES_AUTOSCALE}.pool-group-deployment-policy`;

export const WAF_WAF_POLICY = `${TEMPLATES_WAF}.waf-policy`;
export const WAF_WAF_PROFILE = `${TEMPLATES_WAF}.waf-profile`;
export const WAF_APPLICATION_RULES = `${TEMPLATES_WAF}.application-rules`;
export const WAF_PSM = `${TEMPLATES_WAF}.psm`;
export const WAF_WAF_CRS = `${TEMPLATES_WAF}.waf-crs`;

export const BOT_BOT_MANAGEMENT_POLICY = `${TEMPLATES_BOT}.bot-management-policy-list`;
export const BOT_BOT_MAPPING = `${TEMPLATES_BOT}.bot-mapping`;

export const ERROR_PAGE_ERROR_PAGE_PROFILE = `${TEMPLATES_ERROR_PAGE}.error-page-profile`;
export const ERROR_PAGE_ERROR_PAGE_BODY = `${TEMPLATES_ERROR_PAGE}.error-page-body`;

/**
 * Infrastructure
 */

export const INFRASTRUCTURE_DASHBOARD = `${INFRASTRUCTURE}.dashboard`;
export const INFRASTRUCTURE_GET_STARTED = `${INFRASTRUCTURE}.get-started`;
export const INFRASTRUCTURE_CLOUD = `${INFRASTRUCTURE}.cloud-list`;
export const INFRASTRUCTURE_CLOUD_RESOURCES = `${INFRASTRUCTURE}.cloud-resources`;
export const INFRASTRUCTURE_GSLB = `${INFRASTRUCTURE}.gslb`;

export const CLOUD_RESOURCES_SERVICE_ENGINE = `${INFRASTRUCTURE_CLOUD_RESOURCES}.serviceengine`;
export const CLOUD_RESOURCES_SEGROUP = `${INFRASTRUCTURE_CLOUD_RESOURCES}.segroup-list`;
export const CLOUD_RESOURCES_NETWORK = `${INFRASTRUCTURE_CLOUD_RESOURCES}.network-list`;
export const CLOUD_RESOURCES_NETWORK_SERVICE = `${INFRASTRUCTURE_CLOUD_RESOURCES}.network-service-list`;
export const CLOUD_RESOURCES_VRF_CONTEXT = `${INFRASTRUCTURE_CLOUD_RESOURCES}.vrf-context`;
export const CLOUD_RESOURECES_AVAILABILITY_ZONE = `${INFRASTRUCTURE_CLOUD_RESOURCES}.availability-zone`;

export const SERVICE_ENGINE_SERVICE_ENGINE_DETAIL = `${CLOUD_RESOURCES_SERVICE_ENGINE}.serviceengine-detail`;

export const SERVICE_ENGINE_DETAIL_SUMMARY = `${SERVICE_ENGINE_SERVICE_ENGINE_DETAIL}.summary`;
export const SERVICE_ENGINE_DETAIL_HS_INSIGHTS = `${SERVICE_ENGINE_SERVICE_ENGINE_DETAIL}.hs-insights`;
export const SERVICE_ENGINE_DETAIL_EVENTS = `${SERVICE_ENGINE_SERVICE_ENGINE_DETAIL}.events`;
export const SERVICE_ENGINE_DETAIL_ALERTS = `${SERVICE_ENGINE_SERVICE_ENGINE_DETAIL}.alerts`;
export const SERVICE_ENGINE_DETAIL_TRAFFIC_CAPTURE = `${SERVICE_ENGINE_SERVICE_ENGINE_DETAIL}.se-traffic-capture`;
export const SERVICE_ENGINE_DETAIL_BGP_PEERS = `${SERVICE_ENGINE_SERVICE_ENGINE_DETAIL}.bgp-peers`;

export const SERVICE_ENGINE_HS_INSIGHTS_DEFAULT = `${SERVICE_ENGINE_DETAIL_HS_INSIGHTS}.default`;

export const SERVICE_ENGINE_TRAFFIC_CAPTURE_DEFAULT = `${SERVICE_ENGINE_DETAIL_TRAFFIC_CAPTURE}.default`;

export const GSLB_GSLB = `${INFRASTRUCTURE_GSLB}.gslb`;

export const GSLB_SITES = `${INFRASTRUCTURE_GSLB}.sites`;
export const GSLB_SUBDOMAINS = `${INFRASTRUCTURE_GSLB}.subdomains`;
export const GSLB_GEO_PROFILE = `${INFRASTRUCTURE_GSLB}.geo-profile`;
export const GSLB_LEADER_CHANGE = `${INFRASTRUCTURE_GSLB}.leader-change`;

/**
 * Administration
 */

export const ADMINISTRATION_DASHBOARD = `${ADMINISTRATION}.dashboard`;
export const ADMINISTRATION_USERS = `${ADMINISTRATION}.users`;
export const ADMINISTRATION_SYSTEM_SETTINGS = `${ADMINISTRATION}.system-settings`;
export const ADMINISTRATION_LICENSING = `${ADMINISTRATION}.licensing`;
export const ADMINISTRATION_CONTROLLER_DETAIL = `${ADMINISTRATION}.controller-detail`;
export const ADMINISTRATION_USER_CREDENTIALS = `${ADMINISTRATION}.user-credentials`;
export const ADMINISTRATION_SUPPORT = `${ADMINISTRATION}.support`;
export const ADMINISTRATION_EXTERNAL_SERVICES = `${ADMINISTRATION}.external-services`;

export const USERS_USER_LIST = `${ADMINISTRATION_USERS}.user-list`;
export const USERS_USER_PROFILE_LIST = `${ADMINISTRATION_USERS}.user-profile-list`;
export const USERS_ROLE_LIST = `${ADMINISTRATION_USERS}.role-list`;
export const USERS_TENANT_LIST = `${ADMINISTRATION_USERS}.tenant-list`;
export const USERS_TENANT_SETTINGS = `${ADMINISTRATION_USERS}.tenant-settings`;

export const CONTROLLER_DETAIL_CLUSTER = `${ADMINISTRATION_CONTROLLER_DETAIL}.cluster`;
export const CONTROLLER_DETAIL_SOFTWARE = `${ADMINISTRATION_CONTROLLER_DETAIL}.software`;
export const CONTROLLER_DETAIL_UPDATE = `${ADMINISTRATION_CONTROLLER_DETAIL}.update`;
export const CONTROLLER_DETAIL_UPLOAD_HSM_PACKAGES = `${ADMINISTRATION_CONTROLLER_DETAIL}.upload-hsm-packages`;
export const CONTROLLER_DETAIL_BACKUP = `${ADMINISTRATION_CONTROLLER_DETAIL}.backup`;
export const CONTROLLER_DETAIL_REPORTS = `${ADMINISTRATION_CONTROLLER_DETAIL}.reports`;

export const CONTROLLER_DETAIL_UPDATE_SYSTEM = `${CONTROLLER_DETAIL_UPDATE}.system`;
export const CONTROLLER_DETAIL_UPDATE_SEG = `${CONTROLLER_DETAIL_UPDATE}.seg`;

export const REPORTS_DETAILS = `${CONTROLLER_DETAIL_REPORTS}.reports-detail`;
export const REPORTS_DETAILS_SYSTEM_READINESS = `${REPORTS_DETAILS}.system-readiness`;
export const REPORTS_DETAILS_DRY_RUN_REPORT = `${REPORTS_DETAILS}.dry-run-report`;
export const REPORTS_DETAILS_SYSTEM_TASK = `${REPORTS_DETAILS}.system-task`;

export const SUPPORT_TECH_SUPPORT = `${ADMINISTRATION_SUPPORT}.techsupport`;
export const SUPPORT_TECH_SUPPORT_DETAIL = `${SUPPORT_TECH_SUPPORT}.tech-support-detail`;
export const SUPPORT_TECH_SUPPORT_DETAILS_READINESS = `${SUPPORT_TECH_SUPPORT_DETAIL}.techsupport-readiness`;
export const SUPPORT_TECH_SUPPORT_DETAILS_TASK = `${SUPPORT_TECH_SUPPORT_DETAIL}.techsupport-task`;
export const SUPPORT_CRASH_REPORTS = `${ADMINISTRATION_SUPPORT}.crashreports`;

export const EXTERNAL_CLOUD_SERVICES = `${ADMINISTRATION_EXTERNAL_SERVICES}.cloud-services`;
export const EXTERNAL_CUSTOMER_PROGRAM = `${ADMINISTRATION_EXTERNAL_SERVICES}.customer-program`;

